import z from 'zod';
import { createProductLogger2 } from '../general/logger';
import { getUser } from './modules/app/selectors';

const ProductLogSchema = z.union([
  z.object({ action: z.literal('Service open') }),
  z.object({
    action: z.literal('Convert'),
    sub_action: z.literal('Success'),
    extra: z.object({
      int_1: z.number(), // "node_id"
    }),
  }),
  z.object({
    action: z.literal('Convert'),
    sub_action: z.literal('Fail'),
    extra: z.object({
      int_1: z.number(), // "node_id"
    }),
  }),
  z.object({
    action: z.literal('Upload'),
    sub_action: z.literal('File'),
  }),
  z.object({
    action: z.literal('Upload'),
    sub_action: z.literal('Complete'),
    extra: z.object({
      int_1: z.number(), // node_id after upload
      text_1: z.string(), // name of the file
      int_2: z.number().nullable(), // Time in milliseconds
      int_3: z.number(), // Size in bytes
    }),
  }),
  z.object({
    action: z.literal('Upload'),
    sub_action: z.literal('Folder'),
  }),
  z.object({
    action: z.literal('Folder'),
    sub_action: z.literal('Create'),
  }),
  z.object({
    action: z.literal('Share'),
    sub_action: z.literal('Create'),
    extra: z.object({
      text_1: z.string(), // "name"
      text_2: z.string(), // "share_id"
    }),
  }),
  z.object({
    action: z.literal('Share'),
    sub_action: z.literal('Delete'),
    extra: z.object({
      text_2: z.string(), // "share_id"
    }),
  }),
  z.object({
    action: z.literal('Share'),
    sub_action: z.literal('Change Lifespan'),
    extra: z.object({
      text_1: z.string(), //"new_expiry"
      text_2: z.string(), //"share_id"
    }),
  }),
  z.object({
    action: z.literal('Favorites'),
    sub_action: z.literal('Add'),
    extra: z.object({
      int_1: z.number(), // "node_id"
      int_2: z.number(), // "id"
    }),
  }),
  z.object({
    action: z.literal('Favorites'),
    sub_action: z.literal('Delete'),
    extra: z.object({
      int_1: z.number(), // "node_id"
      int_2: z.number(), // "id"
      int_3: z.number(), // "favorite_id"
      text_1: z.string(), // "name"
    }),
  }),
  z.object({
    action: z.literal('Search'),
    sub_action: z.literal('By Filename'),

    extra: z.object({
      text_1: z.string(), // "query"
      // AI-режим — семантический поиск по разметке Plot Recognition (MYUA-16771).
      // Отдельным флагом, а не новым sub_action, чтобы не ломать существующую аналитику;
      // так же сделано в Asset Lab.
      bool_1: z.boolean().optional(),
    }),
  }),
  z.object({
    action: z.literal('Search'),
    sub_action: z.literal('By Tags'),
  }),
  z.object({
    action: z.literal('File'),
    sub_action: z.literal('Rename'),
    extra: z.object({
      int_1: z.number(), //"node_id"
      // int_2: z.number() // "user_id"
      text_1: z.string(), //"new_name"
    }),
  }),
  z.object({
    action: z.literal('File'),
    sub_action: z.literal('Copy'),
    extra: z.object({
      int_1: z.number(), // "node_id"
      // int_2: z.number(), // "user_id"
      int_3: z.number(), // "target_node_id"
    }),
  }),
  z.object({
    action: z.literal('File'),
    sub_action: z.literal('Move'),
    extra: z.object({
      int_1: z.number(), // "node_id"
      // int_2: z.number() // "user_id"
      int_3: z.number(), //"target_node_id"
    }),
  }),
  z.object({
    action: z.literal('File'),
    sub_action: z.literal('Download'),
    extra: z.object({
      // int_2: z.number() //"user_id"
    }),
  }),
  z.object({
    action: z.literal('File'),
    sub_action: z.literal('Delete'),
    extra: z.object({
      int_1: z.number(), //"node_id"
      // int_2: z.number() //"user_id"
    }),
  }),
  z.object({
    action: z.literal('File'),
    sub_action: z.literal('Permissions'),
    extra: z.object({
      int_1: z.number(), // "node_id"
      // int_2: z.number() // "user_id"
    }),
  }),
  z.object({
    action: z.literal('Tag'),
    sub_action: z.literal('Create'),
    extra: z.object({
      int_1: z.number(), //  "name"
      text_1: z.string(), //  "tag_id"
    }),
  }),
]);

const _logger = createProductLogger2('crhub', getUser, ProductLogSchema);

export const logger = {
  lapi: _logger.loggerLapi,
};
